module.exports = __webpack_public_path__ + "static/media/connection-bg.b7b8e976.png";